import React, { FC } from 'react';
import SCheckbox from './Checkbox.styles';
import { TCheckboxProps } from './Checbox.types';

const Checkbox: FC<TCheckboxProps> = (props) => {
  return <SCheckbox {...props} />;
};

export default Checkbox;
